import { render, staticRenderFns } from "./RetireResponsibility.vue?vue&type=template&id=f54deedc"
import script from "./RetireResponsibility.vue?vue&type=script&lang=js"
export * from "./RetireResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports